// Sessions reads the journal's metadata cache; only outbox transactions can change a draft.
import { readDraft, watchOutbox, type JournalDraft } from '../outbox.ts'

export const preview = (draft?: JournalDraft): string => draft ? [draft.text.split(/\r?\n/, 1)[0].trim(),
  ...(draft.chips ?? []), draft.attachments ? `${draft.attachments} attachment${draft.attachments === 1 ? '' : 's'}` : ''].filter(Boolean).join(' · ') : ''
export const read = (ref: string): string => preview(readDraft(ref, true))
export function subscribe(ref: string, listener: () => void): () => void {
  let previous = read(ref)
  return watchOutbox(() => { const next = read(ref); if (next !== previous) { previous = next; listener() } })
}
